import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "@tanstack/react-router";
import { api, queryKeys, setApiOrg, setApiProject } from "../../api";
import { SessionsTable } from "../../components/SessionsTable";
import { ErrorState, Skeleton } from "../../components/States";
import { PageHeader } from "../../components/ui";
import { staffApi, staffKeys } from "./api";

export function StaffSessionsPage() {
  const { org: orgId } = useParams({ strict: false }) as { org: string };
  const navigate = useNavigate();
  const detail = useQuery({ queryKey: staffKeys.org(orgId), queryFn: () => staffApi.org(orgId) });
  useEffect(() => {
    setApiOrg(orgId);
    const proj = detail.data?.projects[0];
    if (proj) setApiProject(proj.id);
  }, [orgId, detail.data]);
  const sessions = useQuery({
    queryKey: queryKeys.sessions({ limit: 50 }),
    queryFn: () => api.sessions({ limit: 50 }),
    enabled: !!detail.data,
  });
  return (
    <div>
      <PageHeader title="Customer sessions" />
      {sessions.isPending ? (
        <Skeleton />
      ) : sessions.isError ? (
        <ErrorState error={sessions.error} />
      ) : (
        <SessionsTable sessions={sessions.data?.items ?? []} onOpen={(id) => void navigate({ to: "/staff/orgs/$org/sessions/$id", params: { org: orgId, id } })} />
      )}
    </div>
  );
}
